import { Download } from 'lucide-react';
import { DOWNLOAD_LINK } from '../../data/landingData';
import { Button } from '../ui/Button';

export function MobileStickyCta() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white/95 p-3 shadow-soft backdrop-blur sm:hidden">
      <Button href={DOWNLOAD_LINK} target="_blank" rel="noreferrer" className="w-full">
        <Download className="mr-2 h-4 w-4" />
        Descargar +Trainer
      </Button>
    </div>
  );
}
